import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isEmpty from "lodash/isEmpty";
import _isFunction from "lodash/isFunction";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input, Button, showSuccess } from 'components';
import { addDocumentFiles, getDocumentFiles, getAllBorrowerDocuments, deleteBorrowerDocument } from 'services';
import { showApiError } from 'utils';
import { filesContainer, uploadCard, selectedFile, documentsList, documentItem, footerActions } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var ACCEPT = 'image/*, application/pdf';
var MAX_SIZE_MB = 30;

var BorrowerFiles = function BorrowerFiles(_ref) {
  var borrowerIdNumber = _ref.borrowerIdNumber,
      documents = _ref.documents,
      getDocuments = _ref.getDocuments,
      onNext = _ref.onNext;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      documentList = _useState2[0],
      setDocumentList = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      file = _useState4[0],
      setFile = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      description = _useState6[0],
      setDescription = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      uploading = _useState8[0],
      setUploading = _useState8[1];

  var fileRef = useRef();
  useEffect(function () {
    documents && setDocumentList(documents);
  }, [documents]);
  useEffect(function () {
    getDocuments && fetchBorrowerDocuments();
  }, []);

  var fetchBorrowerDocuments = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllBorrower, _yield$getAllBorrower2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllBorrowerDocuments(borrowerIdNumber);

            case 2:
              _yield$getAllBorrower = _context.sent;
              _yield$getAllBorrower2 = _slicedToArray(_yield$getAllBorrower, 2);
              res = _yield$getAllBorrower2[0];
              err = _yield$getAllBorrower2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setDocumentList(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchBorrowerDocuments() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleFileSelect = function handleFileSelect(e) {
    var _e$target$files;

    var selected = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
    if (!selected) return;

    if (selected.size > MAX_SIZE_MB * 1024 * 1024) {
      showApiError({
        message: "\u0424\u0430\u0439\u043B\u044A\u0442 \u0435 \u0442\u0432\u044A\u0440\u0434\u0435 \u0433\u043E\u043B\u044F\u043C. \u041C\u0430\u043A\u0441. ".concat(MAX_SIZE_MB, " MB.")
      });
      return;
    }

    setFile(selected);
  };

  var handleUpload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var formData, _yield$addDocumentFil, _yield$addDocumentFil2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (file) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (description.trim()) {
                _context2.next = 5;
                break;
              }

              showApiError({
                message: 'Моля добавете описание.'
              });
              return _context2.abrupt("return");

            case 5:
              setUploading(true);
              formData = new FormData();
              formData.append('file', file);
              formData.append('description', description);
              _context2.next = 11;
              return addDocumentFiles(borrowerIdNumber, formData);

            case 11:
              _yield$addDocumentFil = _context2.sent;
              _yield$addDocumentFil2 = _slicedToArray(_yield$addDocumentFil, 2);
              res = _yield$addDocumentFil2[0];
              err = _yield$addDocumentFil2[1];
              setUploading(false);

              if (!err) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 18:
              showSuccess('Файлът е качен успешно.');
              setDocumentList(function (prev) {
                return [].concat(_toConsumableArray(prev), [res]);
              });
              setFile(null);
              setDescription('');
              if (fileRef.current) fileRef.current.value = '';

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpload() {
      return _ref3.apply(this, arguments);
    };
  }();

  var openInNewTab = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(el) {
      var _yield$getDocumentFil, _yield$getDocumentFil2, res, err, url;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getDocumentFiles(borrowerIdNumber, el === null || el === void 0 ? void 0 : el.id);

            case 2:
              _yield$getDocumentFil = _context3.sent;
              _yield$getDocumentFil2 = _slicedToArray(_yield$getDocumentFil, 2);
              res = _yield$getDocumentFil2[0];
              err = _yield$getDocumentFil2[1];

              if (!err) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(res);
              window.open(url, '_blank', 'noreferrer', 'noopener');

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function openInNewTab(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(el) {
      var _yield$deleteBorrower, _yield$deleteBorrower2, err;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return deleteBorrowerDocument(borrowerIdNumber, el === null || el === void 0 ? void 0 : el.id);

            case 2:
              _yield$deleteBorrower = _context4.sent;
              _yield$deleteBorrower2 = _slicedToArray(_yield$deleteBorrower, 2);
              err = _yield$deleteBorrower2[1];

              if (!err) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 7:
              setDocumentList(function (prev) {
                return prev.filter(function (d) {
                  return d.id !== el.id;
                });
              });
              showSuccess('Документът е изтрит.');

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleDelete(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleNext = function handleNext() {
    _isFunction(onNext) && onNext();
  };

  return ___EmotionJSX("div", {
    style: filesContainer
  }, ___EmotionJSX("input", {
    ref: fileRef,
    type: "file",
    accept: ACCEPT,
    onChange: handleFileSelect,
    style: {
      display: 'none'
    }
  }), ___EmotionJSX("div", {
    css: uploadCard
  }, ___EmotionJSX("div", {
    className: "upload-fields"
  }, ___EmotionJSX("div", {
    className: "upload-description"
  }, ___EmotionJSX(Input, {
    label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
    required: true,
    value: description,
    onChange: function onChange(val) {
      return setDescription(val !== null && val !== void 0 ? val : '');
    },
    placeholder: "\u041D\u0430\u043F\u0440. \u041B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430, \u0423\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0435\u043D\u0438\u0435..."
  })), !file ? ___EmotionJSX("div", {
    className: "upload-dropzone",
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      var _fileRef$current;

      return (_fileRef$current = fileRef.current) === null || _fileRef$current === void 0 ? void 0 : _fileRef$current.click();
    }
  }, ___EmotionJSX("i", {
    className: "las la-cloud-upload-alt"
  }), ___EmotionJSX("span", null, "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0444\u0430\u0439\u043B"), ___EmotionJSX("small", null, "jpg, png, pdf - \u043C\u0430\u043A\u0441. ", MAX_SIZE_MB, " MB")) : ___EmotionJSX("div", {
    css: selectedFile
  }, ___EmotionJSX("i", {
    className: "las la-file"
  }), ___EmotionJSX("span", {
    className: "file-name"
  }, file.name), ___EmotionJSX("span", {
    className: "file-remove",
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      setFile(null);
      if (fileRef.current) fileRef.current.value = '';
    }
  }, ___EmotionJSX("i", {
    className: "las la-times"
  })))), ___EmotionJSX(Button, {
    onClick: handleUpload,
    disabled: uploading || !file || !description.trim(),
    fullWidth: true
  }, ___EmotionJSX("i", {
    className: "las la-upload",
    style: {
      marginRight: 6
    }
  }), uploading ? 'Качване...' : 'Качи документ')), ___EmotionJSX("div", {
    css: documentsList
  }, ___EmotionJSX("div", {
    className: "docs-title"
  }, ___EmotionJSX("h6", null, "\u041A\u0430\u0447\u0435\u043D\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"), !_isEmpty(documentList) && ___EmotionJSX("span", {
    className: "docs-count"
  }, documentList.length, " \u0444\u0430\u0439\u043B(\u0430)")), _isEmpty(documentList) ? ___EmotionJSX("p", {
    css: function css(theme) {
      return {
        fontSize: '1.3rem',
        color: theme.gray400,
        textAlign: 'center',
        padding: '1.5em 0'
      };
    }
  }, "\u041D\u044F\u043C\u0430 \u043A\u0430\u0447\u0435\u043D\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438") : documentList.map(function (el) {
    return ___EmotionJSX("div", {
      css: documentItem,
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("div", {
      className: "doc-info",
      role: "button",
      tabIndex: "0",
      onClick: function onClick() {
        return openInNewTab(el);
      }
    }, ___EmotionJSX("i", {
      className: "las la-file-alt"
    }), ___EmotionJSX("span", {
      className: "doc-name"
    }, (el === null || el === void 0 ? void 0 : el.description) || 'Документ')), ___EmotionJSX("div", {
      className: "doc-actions"
    }, ___EmotionJSX("span", {
      className: "doc-action-btn",
      role: "button",
      tabIndex: "0",
      title: "\u041E\u0442\u0432\u043E\u0440\u0438",
      onClick: function onClick() {
        return openInNewTab(el);
      }
    }, ___EmotionJSX("i", {
      className: "las la-external-link-alt"
    })), ___EmotionJSX("span", {
      className: "doc-action-btn doc-delete",
      role: "button",
      tabIndex: "0",
      title: "\u0418\u0437\u0442\u0440\u0438\u0439",
      onClick: function onClick() {
        return handleDelete(el);
      }
    }, ___EmotionJSX("i", {
      className: "las la-trash-alt"
    }))));
  })), onNext && ___EmotionJSX("div", {
    style: footerActions
  }, ___EmotionJSX(Button, {
    onClick: handleNext
  }, "\u041D\u0430\u043F\u0440\u0435\u0434")));
};

BorrowerFiles.propTypes = {
  borrowerIdNumber: PropTypes.string,
  documents: PropTypes.array,
  getDocuments: PropTypes.bool,
  onNext: PropTypes.func
};
export default BorrowerFiles;